/* eslint-disable consistent-return */
import styled from "styled-components";
import { Button, FormControlLabel, Popover } from "@mui/material";

import { Cross } from "@/assets/icons";
import { breakpoints } from "@/styles/breakpoints";

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    @media ${breakpoints.xs} {
        flex-direction: column;
    }
`;

export const RowContainer = styled.div`
    display: flex;
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    text-align: center;

    @media ${breakpoints.xs} {
        width: 100%;
    }
`;

export const FilterButton = styled(Button)<{ $active: boolean }>`
    min-width: 40px !important;
    height: 40px;
    font-size: var(--size-14);
    color: var(--color-grey-900);
    text-transform: none;
    background: var(--color-white);
    border: 1px solid var(--color-grey-600);
    border-radius: var(--radius-10);
    box-shadow: none;

    &:hover {
        box-shadow: none;
    }

    svg path {
        fill: var(--color-secondary);
    }

    @media ${breakpoints.xs} {
        width: 100%;
    }

    ${(props) =>
        props.$active &&
        `
            background: var(--color-secondary-light) !important;
  `}
`;

export const LineSeparator = styled.div`
    border-bottom: 1px solid var(--color-grey-600);
    width: calc(100% + 32px);
    margin-left: -16px;
`;

export const StyledPopover = styled(Popover)`
    .popover-paper {
        padding: 8px 16px;
        margin-top: 10px;
        border-radius: var(--radius-5);
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

        @media ${breakpoints.xs} {
            position: fixed;
            top: -10px !important;
            left: 0 !important;
            width: 100%;
            height: 100%;
            padding: 16px;
            max-height: 100% !important;
            border-radius: 0;
        }
    }

    .search {
        box-shadow: none;

        .searchIcon {
            width: auto;
        }

        input {
            padding-left: 30px;
            font-size: var(--size-12);
            font-style: italic;
            font-weight: 400;
            line-height: 18px;
            color: var(--color-grey-800);
        }
    }
`;

export const FilterOptions = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MobilePageTitle = styled.div`
    font-size: var(--size-16);
    line-height: 24px;
    color: var(--color-primary);
`;

export const CloseIconMobile = styled(Cross)`
    width: 24px;
    height: 24px;
    cursor: pointer;

    path {
        fill: var(--color-secondary);
    }
`;

export const CleanFilters = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    margin-bottom: 4px;
    font-size: var(--size-12);
    font-weight: bold;
    line-height: 18px;
    color: var(--color-secondary);
    text-transform: uppercase;
    cursor: pointer;

    @media ${breakpoints.xs} {
        margin-top: 0;
        margin-bottom: 0;
    }
`;

export const StyledFormControlLabel = styled(FormControlLabel)<{
    $selectionDisabled: boolean;
    $unselectionDisabled: boolean;
}>`
    ${({ $selectionDisabled, $unselectionDisabled }) => {
        switch (true) {
            case $selectionDisabled:
                return `rect {
                    fill: var(--color-grey-700);
                    stroke: var(--color-grey-700);
                }`;
            case $unselectionDisabled:
                return `rect {
                    stroke: var(--color-grey-700);
                }
                .filterOptionLabel {
                    color: var(--color-grey-700);
                }`;
        }
    }}
`;

export const FilterOptionLabel = styled.span`
    font-size: var(--size-14);
    font-weight: normal;
    line-height: 21px;
    color: var(--color-grey-900);
`;
